import EventEdit from "@share/event-edit/EventEdit.vue";
import {SchemaSettings} from "@api/models/objects/SchemaSettings";
import {Event} from "@api/models/Event";
import {eventConverter} from "@api/models/objects/Converters";

export const initDataLoader =
    async (component: EventEdit, schemaSettings: SchemaSettings<Event>) => {
        try {
            return await Promise.all([
                component.objectsService?.getDataForAllLanguages<Event>({
                    schema: component.schemaId,
                    objectId: component.eventId,
                    converter: eventConverter,
                    include: Event.FillableFields,
                    schemaSettings: schemaSettings
                }, component.languagesService?.list || [])
            ]);
        }
        catch (e) {
            await component.$store.dispatch('reportException', e);
            return [null];
        }
}
